<template>
  <layout>
    <page-header :header="$t('vehicles.create')" :actions="headerActions">
      <template v-slot:default="props">
        <span
          :class="{
            'btn-primary': rideType === props.action.rideType,
            'btn-default': rideType !== props.action.rideType,
          }"
          class="btn"
        >
          {{ props.action.text }}
        </span>
      </template>
    </page-header>
    <div class="content">
      <resource-form
        :ride-type="rideType"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'vehicles'

export default {
  name: 'VehicleCreate',

  components: {
    ResourceForm,
  },

  data() {
    return {
      rideType: 'transfer',
    }
  },
  computed: {
    headerActions() {
      return [
        {
          text: this.$t('enums.ride_type.transfer'),
          onClick: this.onActionClick,
          rideType: 'transfer',
        },
        {
          text: this.$t('enums.ride_type.city_taxi'),
          onClick: this.onActionClick,
          rideType: 'city_taxi',
        },
        {
          text: this.$t('enums.ride_type.delivery'),
          onClick: this.onActionClick,
          rideType: 'delivery',
        },
      ]
    },
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
    onActionClick(action) {
      this.rideType = action.rideType
    },
  },
}
</script>
